/*
*  项目基础信息组件
*/

import { useState, useEffect } from 'react';
import CNF from '../../incs/Config.js';
import {
    ConfigProvider,
    Row,
    Col,
    Modal,
    Button,
} from 'antd';
import { locale, Html2pdf, } from '../../incs/FunHelper.js';

import ZHCLOGO from '../../images/yd_logo.jpg';
import XZTLOGO from '../../images/logo_head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';


/***
 * 打印工单
 */
const WOInfo = (props) => {
    const [open, setOpen] = useState(false);

    const cancel = () => { setOpen(false); }
    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => { Html2pdf('print-info-id', props.record.number, ''); };

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            <Modal
                style={{ top: 0 }}
                closable={false}
                maskClosable={true}
                open={open}
                keyboard={true}
                width={820}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='submit' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download} style={{ marginRight: '24px' }}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={props.preGroup === 'zhc' ? ZHCLOGO : XZTLOGO} height={props.preGroup === 'zhc' ? '80px' : '45px'} alt={props.preGroup === 'zhc' ? '智慧城' : CNF.companyShortName} /></Col>
                            {
                                props.preGroup === 'xzt' ? <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt={CNF.companyShortName} /></Col> : ''
                            }
                        </Row>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='24' ><h2>项目基础信息</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td colSpan='4' style={{ width: 120 }}>项目编号:</td><td colSpan='20' style={{ width: 600 }}>{props.record.number}</td></tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>项目名称:</td><td colSpan='20' style={{ width: 600 }}>{props.record.name}</td></tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>项目区域:</td><td colSpan='20' style={{ width: 600 }}>{props.record.area_name}</td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>项目类型:</td><td colSpan='8' style={{ width: 240 }}>{props.record.type}</td>
                                    <td colSpan='4' style={{ width: 120 }}>项目阶段:</td><td colSpan='8' style={{ width: 240 }}>{props.record.phase}</td>
                                </tr>
                                {
                                    props.btnLists && props.btnLists.indexOf('btn_plms_om') >= 0 ? <tr><td colSpan='4' style={{ width: 120 }}>维护内容:</td><td colSpan='20' style={{ width: 600 }}>
                                        {props.record.maintenance_content && props.record.maintenance_content.split('\n').map((item, index) => {
                                            return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                        })}
                                    </td></tr> : ''
                                }

                                <tr><td colSpan='4' style={{ width: 120 }}>备注:</td><td colSpan='20' style={{ width: 600 }}>
                                    {props.record.description && props.record.description.split('\n').map((item, index) => {
                                        return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </ConfigProvider>
    );
}

export default WOInfo;